import { useEffect, useState } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar} from '@mui/x-date-pickers';
import { sxCalendar } from './sxProps';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import { LinhaTempoCalendarProps } from '../../../interfaces/props/SaudeOnline/LinhaTempo/LinhaTempoCalendarProps';

dayjs.locale('pt-br');

function Calendar(props: LinhaTempoCalendarProps){
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

    useEffect(() => {
      if(props.selectedDate !== null){
        setSelectedDate(dayjs(props.selectedDate))
      }
    }, [props.selectedDate])

    const handleDateChange = (date: Dayjs | null) => {
      if(date !== null){
        setSelectedDate(date);
        props.handleDate(date.toDate())
      }
    }

    const getDayName = (dayNumber: string) => {
        switch (dayNumber) {
          case 'Do':
            return 'D';
          case '2ª':
            return 'S';
          case '3ª':
            return 'T';
          case '4ª':
            return 'Q';
          case '5ª':
            return 'Q';
          case '6ª':
            return 'S';
          case 'Sá':
            return 'S';
        }
    }

    function disableDays(date: Dayjs) {
      return date.isBefore(dayjs(), 'day');
    }
    
    return (
        <div className="calendar">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar 
                    sx={sxCalendar} 
                    value={selectedDate}
                    onChange={handleDateChange}
                    shouldDisableDate={disableDays}
                    dayOfWeekFormatter={(day: string) => `${getDayName(day)}`}
                />
            </LocalizationProvider>
        </div>
    );
}

export default Calendar;